import React from 'react';
import QuickActionCard from './QuickActionCard';

const ApproverActions = ({ userRoles }) => {
  // Only render for Approvers - Early return for performance
  if (!userRoles.includes('Approver')) {
    return null;
  }

  return (
    <>
      <QuickActionCard
        to="/claims?status=RECOMMENDED_FOR_APPROVAL"
        title="Pending Approvals"
        description="Review and approve/reject claims awaiting decision"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        }
        iconColor="text-blue-600"
        hoverIconColor="group-hover:text-blue-700"
        titleHoverColor="group-hover:text-blue-700"
        badge="pending"
      />

      <QuickActionCard
        to="/claims?status=APPROVED"
        title="Approved Claims"
        description="View recently approved claims"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
        }
        iconColor="text-green-600"
        hoverIconColor="group-hover:text-green-700"
        titleHoverColor="group-hover:text-green-700"
      />

      <QuickActionCard
        to="/claims?slaStatus=AT_RISK"
        title="High Priority"
        description="Claims with less than 20% SLA time remaining"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z" />
        }
        iconColor="text-red-600"
        hoverIconColor="group-hover:text-red-700"
        titleHoverColor="group-hover:text-red-700"
        badge="urgent"
      />

      <QuickActionCard
        to="/sla-dashboard"
        title="SLA Monitoring"
        description="Monitor service level agreements and escalation status"
        icon={
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        }
        iconColor="text-orange-600"
        hoverIconColor="group-hover:text-orange-700"
        titleHoverColor="group-hover:text-orange-700"
        badge="sla"
      />
    </>
  );
};

export default React.memo(ApproverActions);
